module.exports = __webpack_public_path__ + "static/media/nfc.fbda1a8e.svg";